import styled from 'styled-components'

export const Text = styled.span`
  margin-right: 0.5rem;
`

export const ParentNode = styled.span`
  font-size: larger;
  font-weight: bold;
  margin-left: 1rem;
`
